export default __webpack_public_path__ + "static/media/protfolio.2a78f0e3.jpg";